$(function() {

    // Intro
    setTimeout(function(){
        $('#siteIntro .site-intro__container').fadeOut('normal', function(){
            $(this).parent().slideUp('normal');
            $('.hero-front .animate__paused').removeClass('animate__paused');
        });
    }, 1500);

    // Loading
    setTimeout(function(){
        $('#siteLoading .site-loading__container').fadeOut('normal', function(){
            $(this).parent().slideUp('normal');
            $('.quiz .animate__paused').removeClass('animate__paused');
        });
    }, 1500);

    // Answers Loading
    setTimeout(function(){
        $('.hero-answers-loading__cta-logo').fadeOut('normal', function(){
            $('.hero-answers-loading__cta .button').removeClass('is-hidden animate__paused');
        });
    }, 4000);

    // Loading Results
    setTimeout(function(){
        $('#siteLoadingResults .site-loading-results__container').fadeOut('normal', function(){
            $(this).parent().slideUp('normal');
            $('.site-results .animate__paused').removeClass('animate__paused');
        });
    }, 3000);

    // JS temporal para el demo de navegación
    $('#question1 input[type=radio][name=question1]').on('change', function() {
        $('#question1 button[type=submit]').prop('disabled', false);
    });
    $('#question2 input[type=radio][name=question2]').on('change', function() {
        $('#question2 button[type=submit]').prop('disabled', false);
    });
    $('#question3 input[type=radio][name=question3]').on('change', function() {
        $('#question3 button[type=submit]').prop('disabled', false);
    });
    $('#question4 input[type=radio][name=question4]').on('change', function() {
        $('#question4 button[type=submit]').prop('disabled', false);
    });
    $('#question5 input[type=radio][name=question5]').on('change', function() {
        $('#question5 button[type=submit]').prop('disabled', false);
    });

    //Smoothscroll
    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            console.log(target);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();

                $('.site-wrapper').animate({
                    scrollTop: target.offset().top
                }, 1000);

            }
        }
    });

    //change navbar class on dark or light sections
    var spSections = $('.sp-section');
    $('.site-wrapper').on('scroll', function(){
        spSections.each(function(){

            var spSection = $(this);
            var bgsection = spSection.data('navbarclass');
            var spSectionOffset = spSection.offset().top;
            var spSectionHeight = spSection.outerHeight();
            var spSectionBottom = spSectionOffset + spSectionHeight;
            var scrollPosition = $(document).scrollTop();
    
            if(scrollPosition < spSectionBottom - 50 && scrollPosition >= spSectionOffset - 50){
                $('.site-navbar').addClass(bgsection);
            } else{
                $('.site-navbar').removeClass(bgsection);
            }
        });
    });
   
});